import { getLink } from "@utils/linkUtils";
import { transparentPixel } from "@utils/string";
import { useLocale } from "next-intl";
import Link from "next/link";
import React, { FC } from "react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Image from "@/components/ui/Image/Image";
import { CustomLink } from "@/types";

interface MiniBrandCardSliderProps {
  miniBrands: CustomLink[];
}

const MiniBrandCardSlider: FC<MiniBrandCardSliderProps> = (miniBrandsProp) => {
  const locale = useLocale();
  return (
    <div className="w-full mx-auto my-l md:mt-0 md:pt-xxl md:pb-3xl">
      <Swiper
        modules={[Autoplay]}
        className="w-full"
        slidesPerView={4}
        centerInsufficientSlides={true}
        autoplay={miniBrandsProp?.miniBrands?.length >= 5 && { delay: 1000 }}
        loop={miniBrandsProp?.miniBrands?.length >= 5}
        breakpoints={{
          0: {
            slidesPerView: 4,
            loop: miniBrandsProp?.miniBrands?.length >= 5,
            autoplay: miniBrandsProp?.miniBrands?.length >= 5 && { delay: 1000 },
          },
          768: {
            slidesPerView: 3.3,
          },
          1024: {
            slidesPerView: 9,
            loop: miniBrandsProp?.miniBrands?.length >= 10,
            autoplay: miniBrandsProp?.miniBrands?.length >= 10 && { delay: 1000 },
          },
        }}
      >
        {miniBrandsProp?.miniBrands?.map((brand, index) => (
          <SwiperSlide key={index}>
            {brand && brand.link.url != "#" ? (
              <Link href={getLink(brand, locale)}>
                <Image
                  className="mx-auto w-18\/24"
                  fit="pad"
                  src={brand.link.image?.url || transparentPixel}
                  alt={brand.label}
                  width={100}
                  height={80}
                />
              </Link>
            ) : (
              <Image
                className="mx-auto w-18\/24"
                fit="pad"
                src={brand.link.image?.url || transparentPixel}
                alt={brand.label}
                width={143}
                height={115}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
export default MiniBrandCardSlider;
